module.exports = __webpack_public_path__ + "img/module-find-clinic.45707326.svg";